import React from 'react'
import Toggle from '../Toggle/Toggle';
import './Navbar.css'
import {Link} from 'react-scroll'
import Services from '../Services/Services';
import Experience from '../Experience/Experience'
import Portfolio from '../Portfolio/Portfolio'

 const Navbar = () => {
  return (
    <div className="n-wrapper">
        <div className="n-left">
             <div className="n-name">Ratikant</div>
             <Toggle/>
        </div>
        <div className="n-right">
            <div className="n-list">
                <ul style={{listStyleType:'none'}}>

                    <Link spy={true} to='Navbar' smooth={true} activeClass='activeClass'>
                    <li>Home</li>
                    </Link>
                    <Link spy={true} to='Services' smooth={true} >
                    <li>Skills</li>
                    </Link>
                    <Link spy={true} to='Experience' smooth={true} >
                    <li>Education</li>
                    </Link>
                    <Link spy={true} to='Portfolio' smooth={true} >
                    <li>Portfolio</li>
                    </Link>
                    <Link spy={true} to='Services' smooth={true} >
                    <li>Resume</li>
                    </Link>
                </ul>
            </div>
            <Link spy={true} to='Contact' smooth={true} activeClass='activeClass'>
            <button className="button n-button">
                Contact
            </button>
            </Link>
        </div>
    </div>
  )
}

export default Navbar;
